import type { JSONSchema7Definition } from "json-schema";

// Feature isolation exception for widget config extraction
// eslint-disable-next-line
import { getRanaWidgetFromProperty } from "@/features/project-process-run-form";

export interface FileResultInfo {
  key: string;
  fileId: string;
  fileRef?: string;
}

export interface DirectoryResultInfo {
  key: string;
  directoryId: string;
}

/**
 * Extracts file info from a job result value
 */
export function extractFileInfo(key: string, value: unknown): FileResultInfo | null {
  if (value && typeof value === "object") {
    const fileId = (value as Record<string, unknown>).id;
    const fileRef = (value as Record<string, unknown>).ref;
    if (fileId && typeof fileId === "string") {
      return { key, fileId, fileRef: fileRef as string | undefined };
    }
  }
  return null;
}

/**
 * Extracts directory info and expected file count from schema property and job result
 */
export function extractDirectoryInfo(key: string, value: unknown): DirectoryResultInfo | null {
  if (value && typeof value === "object") {
    const directoryId = (value as Record<string, unknown>).id;
    if (directoryId && typeof directoryId === "string") {
      return { key, directoryId };
    }
  }
  return null;
}

/**
 * Gets expected file count from directory widget configuration
 */
export function getExpectedFileCount(property: JSONSchema7Definition): number {
  const widget = getRanaWidgetFromProperty(property, "directory_picker");
  return widget ? Object.values(widget.expected_files || {}).length : 0;
}
